enum Ethnicity {
  WHITEBRITISH = "whiteBritish",
  WHITEIRISH= "whiteIrish",
  WHITEOTHER= "whiteOther",
  MIXEDWHITEANDBLACKCARIBBEAN= "mixedWhiteAndBlackCaribbean",
  MIXEDWHITEANDBLACKAFRICAN= "mixedWhiteAndBlackAfrican",
  MIXEDWHITEANDASIAN= "mixedWhiteAndAsian",
  MIXEDOTHER= "mixedOther",
  ASIANINDIAN= "asianIndian",
  ASIANPAKISTANI= "asianPakistani",
  ASIANBANGLADESHI= "asianBangladeshi",
  ASIANBRITISHOTHER= "asianBritishOther",
  BLACKCARIBBEAN= "blackCaribbean",
  BLACKAFRICAN= "blackAfrican",
  BLACKBRITISH= "blackBritish",
  OTHERCHINESE= "otherChinese",
  ANYOTHERETHNICGROUP= "anyOtherEthnicGroup",
  PREFERNOTTOSAY= "preferNotToSay",
  UNDEFINED = ""
};

export default Ethnicity;

export const ethnicityOptions = [
  { value: "whiteBritish", label: "White: British" },
  { value: "whiteIrish", label: "White: Irish" },
  { value: "whiteOther", label: "White: Any other White background", },
  { value: "mixedWhiteAndBlackCaribbean", label: "Mixed: White and Black Caribbean",  },
  { value: "mixedWhiteAndBlackAfrican", label: "Mixed: White and Black African",  },
  { value: "mixedWhiteAndAsian", label: "Mixed: White and Asian",  },
  { value: "mixedOther", label: "Mixed: Any other mixed background",  },
  { value: "asianIndian",  label: "Asian or Asian British: Indian", },
  { value: "asianPakistani", label: "Asian or Asian British: Pakistani", },
  { value: "asianBangladeshi", label: "Asian or Asian British: Bangladeshi", },
  { value: "asianBritishOther", label: "Asian or Asian British: Any other Asian background", },
  { value: "blackCaribbean", label: "Black or Black British: Caribbean", },
  { value: "blackAfrican", label: "Black or Black British: African", },
  { value: "blackBritish", label: "Black or Black British: Any other Black background", },
  { value: "otherChinese", label: "Other Ethnic Groups: Chinese", },
  { value: "anyOtherEthnicGroup", label: "Other Ethnic Groups: Any other ethnic group", },
  { value: "preferNotToSay",  label: "Prefer not to say",  },
];

export const BAME = [
  Ethnicity.MIXEDWHITEANDBLACKCARIBBEAN,
  Ethnicity.MIXEDWHITEANDBLACKAFRICAN,
  Ethnicity.MIXEDWHITEANDASIAN,
  Ethnicity.MIXEDOTHER,
  Ethnicity.ASIANINDIAN,
  Ethnicity.ASIANPAKISTANI,
  Ethnicity.ASIANBANGLADESHI,
  Ethnicity.ASIANBRITISHOTHER,
  Ethnicity.BLACKCARIBBEAN,
  Ethnicity.BLACKAFRICAN,
  Ethnicity.BLACKBRITISH,
  Ethnicity.OTHERCHINESE,
  Ethnicity.ANYOTHERETHNICGROUP,
];

export const NONBAME = [
  Ethnicity.WHITEBRITISH,
  Ethnicity.WHITEIRISH,
  Ethnicity.WHITEOTHER,
];
